<template>
  <div class="upload-view">
    <div v-for="product in workbench.products" :key="product.id" class="product-row-wrapper">
      <ProductRow :product="product" />
    </div>
  </div>
</template>

<script setup>
import { useWorkbenchStore } from '@/stores/useWorkbenchStore'
import ProductRow from '@/components/upload/ProductRow.vue'

const workbench = useWorkbenchStore()
</script>
